import { GetServerSidePropsContext } from 'next';
import { createContext, useContext } from 'react';

export interface AppConfig {
  API_URL?: string;
  MEMBERS_API_URL?: string;
  uaString?: string;
  environmentName?: string;
  STRAPI_URL?: string;
}

export const getAppConfig = (ctx: GetServerSidePropsContext): AppConfig => {
  return {
    API_URL: process.env.NEXT_PUBLIC_API_URL,
    MEMBERS_API_URL: process.env.NEXT_PUBLIC_MEMBERS_API_URL,
    uaString: ctx.req.headers['user-agent'],
    environmentName: process.env.NEXT_PUBLIC_ENVIRONMENT,
    STRAPI_URL: `${process.env.STRAPI_BASE_URL}`,
  };
};

const AppConfigProvider = createContext<AppConfig>({});

export const useAppContext = () => {
  return useContext(AppConfigProvider);
};

export default AppConfigProvider;
